// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   MenuItem,
//   Typography,
//   Button,
//   Switch,
//   FormControlLabel,
//   Paper,
//   RadioGroup,
//   Radio,
//   InputAdornment,
//   Select,
// } from "@mui/material";
// import ButtonComp from "../../../../components/Button";
// import Input from "../../../../components/Input";
// import theme from "../../../../theme";
// import check from "../../../../assets/images/check.svg";
// import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
// import { useCountryOptions } from "../../../../hooks/useCountryOptions";
// import { useOtpVerifiedStore } from "../../../../store/useOtpVerifiedStore";
// import OtpPopup from "../../../../components/OtpPopup";
// import VerifiedPopup from "../../../../components/VerifiedPopup";
// import { useToast } from "../../../../hooks/useToast";
// import { useOtp } from "../../../../hooks/useOtp";
// import { verifyOtp } from "../../../../services/guest";
// import { useVerifiedStore } from "../../../../store/useVerifiedStore";
// import { useRelationOptions } from "../../../../hooks/useRelationOptions";

// const countryCodes = [
//   { label: "South Africa (+27)", code: "+27" },
//   { label: "India (+91)", code: "+91" },
//   { label: "USA (+1)", code: "+1" },
//   { label: "UK (+44)", code: "+44" },
// ];

// export default function InformantDetails({ onNext }: any) {
//   const [countryCode, setCountryCode] = useState("+27");
//   const [otpValue, setOtpValue] = useState("");
//   const [showOtp, setShowOtp] = useState(false);
//   const [errors, setErrors] = useState<Record<string, string>>({});

//   const { informantDetails, setInformantDetails } = useCaseCreationStore();
//   const { relationOptions, loading } = useRelationOptions();
//   const { countryOptions } = useCountryOptions();
//   const showVerified = useVerifiedStore((state) => state.showVerified);
//   const setShowVerified = useVerifiedStore((state) => state.setShowVerified);
//   const { setIsOtpVerified, isOtpVerified } = useOtpVerifiedStore();
//   const { showInfoToast } = useToast();
//   const { sendOtp } = useOtp();

//   const cellPhoneNumber = `${countryCode}${informantDetails.contactNumber}`;

//   const validateSouthAfricanID = (id: string): string | null => {
//     // must be 13 digits
//     if (!/^\d{13}$/.test(id)) return "ID number must be 13 digits";

//     // Extract parts
//     const dob = id.substring(0, 6);
//     const ssss = parseInt(id.substring(6, 10), 10);
//     const citizenship = parseInt(id.charAt(10), 10);
//     const checkDigit = id.charAt(12);

//     // Validate DOB
//     const year = parseInt(dob.substring(0, 2), 10);
//     const month = parseInt(dob.substring(2, 4), 10);
//     const day = parseInt(dob.substring(4, 6), 10);
//     const fullYear = year < 50 ? 2000 + year : 1900 + year;

//     const date = new Date(fullYear, month - 1, day);
//     if (
//       date.getFullYear() !== fullYear ||
//       date.getMonth() + 1 !== month ||
//       date.getDate() !== day
//     ) {
//       return "Invalid date of birth in ID number";
//     }

//     // Validate gender sequence
//     if (ssss < 0 || ssss > 9999) {
//       return "Invalid gender sequence in ID number";
//     }

//     // Validate citizenship
//     if (![0, 1, 2].includes(citizenship)) {
//       return "Invalid citizenship digit in ID number";
//     }

//     // Luhn checksum
//     const luhnCheck = (num: string) => {
//       let sum = 0;
//       let alt = false;
//       for (let i = num.length - 1; i >= 0; i--) {
//         let n = parseInt(num.charAt(i), 10);
//         if (alt) {
//           n *= 2;
//           if (n > 9) n -= 9;
//         }
//         sum += n;
//         alt = !alt;
//       }
//       return sum % 10 === 0;
//     };

//     if (!luhnCheck(id)) return "Invalid ID number checksum";

//     return null; // ✅ Valid
//   };

//   const validateForm = () => {
//     const newErrors: Record<string, string> = {};

//     if (!informantDetails.title) newErrors.title = "Title is required";

//     if (!informantDetails.initials)
//       newErrors.initials = "Initials are required";

//     if (!informantDetails.firstName)
//       newErrors.firstName = "First name is required";

//     if (!informantDetails.lastName)
//       newErrors.lastName = "Last name is required";

//     if (!informantDetails.gender) newErrors.gender = "Gender is required";

//     if (!informantDetails.dateOfBirth)
//       newErrors.dateOfBirth = "Date of birth is required";

//     if (!informantDetails.maritalStatus)
//       newErrors.maritalStatus = "Marital status is required";

//     if (!informantDetails.relationship)
//       newErrors.relationship = "Relationship is required";

//     if (!informantDetails.nationality)
//       newErrors.nationality = "Nationality is required";

//     if (!informantDetails.countryOfBirth)
//       newErrors.countryOfBirth = "Country of birth is required";

//     if (!informantDetails.countryOfResidence)
//       newErrors.countryOfResidence = "Country of residence is required";

//     if (!informantDetails.email) newErrors.email = "Email is required";
//     else if (!/^\S+@\S+\.\S+$/.test(informantDetails.email))
//       newErrors.email = "Invalid email format";

//     if (!informantDetails.address) newErrors.address = "Address is required";

//     if (!informantDetails.postalAddress)
//       newErrors.postalAddress = "Postal address is required";

//     if (!informantDetails.contactNumber)
//       newErrors.contactNumber = "Contact number is required";

//     if (!isOtpVerified)
//       newErrors.contactNumber = "Please verify your cellphone number";

//     if (!informantDetails.identificationType)
//       newErrors.identificationType = "Select ID or Passport";

//     if (!informantDetails.identificationNumber)
//       newErrors.identificationNumber = "Identification number is required";

//     // South African ID validation
//     if (
//       informantDetails.identificationType === "id" &&
//       informantDetails.identificationNumber
//     ) {
//       const idError = validateSouthAfricanID(
//         informantDetails.identificationNumber,
//       );
//       if (idError) newErrors.identificationNumber = idError;
//     }

//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   const handleNextClick = () => {
//     const isValid = validateForm();

//     if (!isValid) return;

//      if (!isOtpVerified) {
//       showInfoToast("Please verify OTP before proceeding.");
//       return;
//     }
//     onNext();
//   };

//   const clearError = (field: string) => {
//     setErrors((prev) => {
//       const updated = { ...prev };
//       delete updated[field];
//       return updated;
//     });
//   };

//   const handleOtpVerification = async () => {
//     if (!informantDetails.contactNumber) {
//       showInfoToast("Please enter your cellphone number before requesting OTP");
//       return;
//     }

//     if (informantDetails.contactNumber.length < 8) {
//       showInfoToast("Please enter a valid cellphone number");
//       return;
//     }
//     setShowOtp(true);
//     const cellPhoneNumber = `${countryCode}${informantDetails.contactNumber}`;
//     await sendOtp(cellPhoneNumber);
//   };

//   const handleOtpVerify = async () => {
//     const cellPhoneNumber = `${countryCode}${informantDetails.contactNumber}`;
//     const res = await verifyOtp(cellPhoneNumber, otpValue);
//     if (res.status === 200 && res.data.success === true) {
//       setOtpValue("");
//       setShowOtp(false);
//       setIsOtpVerified(true);
//       setShowVerified(true);
//     } else if (res.data.success === false) {
//       setOtpValue("");
//       setShowOtp(false);
//       showInfoToast(res.data.message);
//     } else {
//       showInfoToast(res.data.message);
//     }
//   };

//   const handleVerifiedClose = () => {
//     setShowVerified(false);
//   };

//   useEffect(() => {
//       if (showVerified) {
//         const timer = setTimeout(() => {
//           setShowVerified(false);
//         }, 2000);
//         return () => clearTimeout(timer);
//       }
//     }, [showVerified]);

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 4,
//         mt: 3,
//         borderRadius: 3,
//         backgroundColor: "#fff",
//       }}
//     >
//       <Grid container spacing={3}>
//         {/* First Name */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Title *"
//             variant="outlined"
//             value={informantDetails.title}
//             onChange={(e: any) => {
//               setInformantDetails({ title: e.target.value });
//               clearError("title");
//             }}
//             error={Boolean(errors.title)}
//             helperText={errors.title}
//           />
//         </Grid>
//         {/* First Name */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Initials *"
//             variant="outlined"
//             value={informantDetails.initials}
//             onChange={(e: any) => {
//               setInformantDetails({ initials: e.target.value });
//               clearError("initials");
//             }}
//             error={Boolean(errors.initials)}
//             helperText={errors.initials}
//           />
//         </Grid>
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="First Name *"
//             variant="outlined"
//             value={informantDetails.firstName}
//             onChange={(e: any) => {
//               setInformantDetails({ firstName: e.target.value });
//               clearError("firstName");
//             }}
//             error={Boolean(errors.firstName)}
//             helperText={errors.firstName}
//           />
//         </Grid>

//         {/* Last Name */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <Input
//             fullWidth
//             label="Last Name *"
//             variant="outlined"
//             value={informantDetails.lastName}
//             onChange={(e: any) => {
//               setInformantDetails({ lastName: e.target.value });
//               clearError("lastName");
//             }}
//             error={Boolean(errors.lastName)}
//             helperText={errors.lastName}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 3 }}>
//           <Input
//             select
//             fullWidth
//             label="Gender"
//             variant="outlined"
//             value={informantDetails.gender}
//             onChange={(e: any) => {
//               setInformantDetails({ gender: e.target.value });
//               clearError("gender");
//             }}
//             error={Boolean(errors.gender)}
//             helperText={errors.gender}
//             SelectProps={{
//               displayEmpty: true,
//               renderValue: (selected: any) =>
//                 selected ? (
//                   selected
//                 ) : (
//                   <span style={{ color: "#aaa" }}>Select Gender</span>
//                 ),
//               MenuProps: {
//                 PaperProps: {
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     borderRadius: "12px",
//                     maxHeight: "300px",
//                   },
//                 },
//               },
//             }}
//           >
//             <MenuItem
//               value="Male"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Male
//             </MenuItem>
//             <MenuItem
//               value="female"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Female
//             </MenuItem>
//             <MenuItem
//               value="other"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Other
//             </MenuItem>
//           </Input>
//         </Grid>

//         <Grid size={{ xs: 12, md: 3 }}>
//           <Input
//             type="date"
//             fullWidth
//             label="Date of Birth"
//             placeholder="DD-MM-YYYY"
//             variant="outlined"
//             value={informantDetails.dateOfBirth || ""}
//             onChange={(e: any) => {
//               setInformantDetails({
//                 dateOfBirth: e.target.value,
//               });
//               clearError("dateOfBirth");
//             }}
//             error={Boolean(errors.dateOfBirth)}
//             helperText={errors.dateOfBirth}
//           />
//         </Grid>
//         <Grid size={{ xs: 12, md: 3 }}>
//           <Input
//             select
//             fullWidth
//             label="Marital status"
//             variant="outlined"
//             value={informantDetails.maritalStatus}
//             onChange={(e: any) => {
//               setInformantDetails({ maritalStatus: e.target.value });
//               clearError("maritalStatus");
//             }}
//             error={Boolean(errors.maritalStatus)}
//             helperText={errors.maritalStatus}
//             SelectProps={{
//               displayEmpty: true,
//               renderValue: (selected: any) =>
//                 selected ? (
//                   selected
//                 ) : (
//                   <span style={{ color: "#aaa" }}>Select Marital Status</span>
//                 ),
//               MenuProps: {
//                 PaperProps: {
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     borderRadius: "12px",
//                     maxHeight: "300px",
//                   },
//                 },
//               },
//             }}
//           >
//             <MenuItem
//               value="divorced"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Divorced
//             </MenuItem>
//             <MenuItem
//               value="married"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Married
//             </MenuItem>
//             <MenuItem
//               value="single"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Single
//             </MenuItem>
//             <MenuItem
//               value="widow"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Widow
//             </MenuItem>
//             <MenuItem
//               value="widower"
//               sx={{
//                 background: "background.default",
//                 borderBottom: `1px solid ${theme.palette.grey[200]}`,
//               }}
//             >
//               Widower
//             </MenuItem>
//           </Input>
//         </Grid>

//         <Grid size={{ xs: 12, md: 3 }}>
//           <Input
//             select
//             fullWidth
//             label="Relationship to deceased"
//             variant="outlined"
//             value={informantDetails.relationship}
//             onChange={(e: any) =>{
//               setInformantDetails({ relationship: e.target.value });
//               clearError("relationship")
//             }
//             }
//             error={Boolean(errors.relationship)}
//             helperText={errors.relationship}
//             SelectProps={{
//               displayEmpty: true,
//               renderValue: (selected: any) =>
//                 selected ? (
//                   selected
//                 ) : (
//                   <span style={{ color: "#aaa" }}>Select Relationship</span>
//                 ),
//               MenuProps: {
//                 PaperProps: {
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     borderRadius: "12px",
//                     maxHeight: "300px",
//                   },
//                 },
//               },
//             }}
//           >
//             {loading ? (
//               <MenuItem disabled>Loading relationships...</MenuItem>
//             ) : (
//               relationOptions.map((relation: string, index) => (
//                 <MenuItem
//                   key={index}
//                   value={relation}
//                   sx={{
//                     background: "background.default",
//                     borderBottom: `1px solid ${theme.palette.grey[200]}`,
//                   }}
//                 >
//                   {relation}
//                 </MenuItem>
//               ))
//             )}
//           </Input>
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             select
//             fullWidth
//             label="Nationality"
//             variant="outlined"
//             value={informantDetails.nationality}
//             onChange={(e: any) => {
//               setInformantDetails({ nationality: e.target.value });
//               clearError("nationality");
//             }}
//             error={Boolean(errors.nationality)}
//             helperText={errors.nationality}
//             SelectProps={{
//               displayEmpty: true,
//               renderValue: (selected: any) =>
//                 selected ? (
//                   selected
//                 ) : (
//                   <span style={{ color: "#aaa" }}>Select Nationality</span>
//                 ),
//               MenuProps: {
//                 PaperProps: {
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     borderRadius: "12px",
//                     maxHeight: "300px",
//                   },
//                 },
//               },
//             }}
//           >
//             {countryOptions.length === 0 ? (
//               <MenuItem disabled>Loading nationality...</MenuItem>
//             ) : (
//               countryOptions.map((option) => (
//                 <MenuItem
//                   key={option}
//                   value={option}
//                   sx={{
//                     background: "background.default",
//                     borderBottom: `1px solid ${theme.palette.grey[200]}`,
//                   }}
//                 >
//                   {option}
//                 </MenuItem>
//               ))
//             )}
//           </Input>
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             select
//             fullWidth
//             label="Country of birth"
//             variant="outlined"
//             value={informantDetails.countryOfBirth}
//             onChange={(e: any) => {
//               setInformantDetails({ countryOfBirth: e.target.value });
//               clearError("countryOfBirth");
//             }}
//             error={Boolean(errors.countryOfBirth)}
//             helperText={errors.countryOfBirth}
//             SelectProps={{
//               displayEmpty: true,
//               renderValue: (selected: any) =>
//                 selected ? (
//                   selected
//                 ) : (
//                   <span style={{ color: "#aaa" }}>Select Countries</span>
//                 ),
//               MenuProps: {
//                 PaperProps: {
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     borderRadius: "12px",
//                     maxHeight: "300px",
//                   },
//                 },
//               },
//             }}
//           >
//             {countryOptions.length === 0 ? (
//               <MenuItem disabled>Loading countries...</MenuItem>
//             ) : (
//               countryOptions.map((option) => (
//                 <MenuItem
//                   key={option}
//                   value={option}
//                   sx={{
//                     background: "background.default",
//                     borderBottom: `1px solid ${theme.palette.grey[200]}`,
//                   }}
//                 >
//                   {option}
//                 </MenuItem>
//               ))
//             )}
//           </Input>
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             select
//             fullWidth
//             label="Country of residence"
//             variant="outlined"
//             value={informantDetails.countryOfResidence}
//             onChange={(e: any) => {
//               setInformantDetails({ countryOfResidence: e.target.value });
//               clearError("countryOfResidence");
//             }}
//             error={Boolean(errors.countryOfResidence)}
//             helperText={errors.countryOfResidence}
//             SelectProps={{
//               displayEmpty: true,
//               renderValue: (selected: any) =>
//                 selected ? (
//                   selected
//                 ) : (
//                   <span style={{ color: "#aaa" }}>Select Countries</span>
//                 ),
//               MenuProps: {
//                 PaperProps: {
//                   sx: {
//                     backgroundColor: "#ffffff",
//                     borderRadius: "12px",
//                     maxHeight: "300px",
//                   },
//                 },
//               },
//             }}
//           >
//             {countryOptions.length === 0 ? (
//               <MenuItem disabled>Loading countries...</MenuItem>
//             ) : (
//               countryOptions.map((option) => (
//                 <MenuItem
//                   key={option}
//                   value={option}
//                   sx={{
//                     background: "background.default",
//                     borderBottom: `1px solid ${theme.palette.grey[200]}`,
//                   }}
//                 >
//                   {option}
//                 </MenuItem>
//               ))
//             )}
//           </Input>
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             fullWidth
//             label="Email"
//             variant="outlined"
//             value={informantDetails.email}
//             onChange={(e: any) => {
//               setInformantDetails({ email: e.target.value });
//               clearError("email");
//             }}
//             error={Boolean(errors.email)}
//             helperText={errors.email}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             fullWidth
//             label="Address"
//             variant="outlined"
//             value={informantDetails.address}
//             onChange={(e: any) => {
//               setInformantDetails({ address: e.target.value });
//               clearError("address");
//             }}
//             error={Boolean(errors.address)}
//             helperText={errors.address}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 4 }}>
//           <Input
//             fullWidth
//             label="Physical/Postal address"
//             variant="outlined"
//             value={informantDetails.postalAddress}
//             onChange={(e: any) => {
//               setInformantDetails({ postalAddress: e.target.value });
//               clearError("postalAddress");
//             }}
//             error={Boolean(errors.postalAddress)}
//             helperText={errors.postalAddress}
//           />
//         </Grid>

//         <Grid size={{ xs: 12, md: 6 }} mt={1.8}>
//           <Typography
//             variant="body1"
//             fontWeight={600}
//             fontSize={18}
//             sx={{ display: "block", textAlign: "left" }}
//           >
//             Informant Cellphone number (for OTP verification)
//           </Typography>
//           <TextField
//             fullWidth
//             type="number"
//             variant="outlined"
//             value={informantDetails.contactNumber}
//             placeholder="Enter Your Cellphone Number"
//             onChange={(e: any) => {
//               setIsOtpVerified(false);
//               setInformantDetails({ contactNumber: e.target.value });
//               clearError("contactNumber");
//             }}
//             error={Boolean(errors.contactNumber)}
//             helperText={errors.contactNumber}
//             sx={{
//               "& .MuiOutlinedInput-root": {
//                 borderRadius: "10px",
//                 height: "60px",
//               },
//               "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
//                 {
//                   WebkitAppearance: "none",
//                   margin: 0,
//                 },
//               "& input[type=number]": {
//                 MozAppearance: "textfield",
//               },
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Select
//                     value={countryCode || "+27"}
//                     onChange={(e: any) => setCountryCode(e.target.value)}
//                     variant="standard"
//                     disableUnderline
//                     sx={{ width: 100 }}
//                   >
//                     {countryCodes.map((item) => (
//                       <MenuItem key={item.code} value={item.code}>
//                         {item.code}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </InputAdornment>
//               ),
//               endAdornment: (
//                 <InputAdornment position="end">
//                   {isOtpVerified ? (
//                     <img
//                       src={check}
//                       alt="check"
//                       style={{ height: 25, width: 25 }}
//                     />
//                   ) : (
//                     <ButtonComp
//                       variant="contained"
//                       width={{ xs: 100, md: 200 }}
//                       onClick={handleOtpVerification}
//                     >
//                       Send OTP
//                     </ButtonComp>
//                   )}
//                 </InputAdornment>
//               ),
//             }}
//           />
//         </Grid>

//         {/* Identity Type */}
//         <Grid size={{ xs: 12, md: 6 }}>
//           <RadioGroup
//             row
//             name="passport"
//             value={informantDetails.identificationType}
//             onChange={(e) => {
//               setInformantDetails({ identificationType: e.target.value });
//               clearError("identificationType");
//             }}
//           >
//             <FormControlLabel value="id" control={<Radio />} label="ID" />
//             <FormControlLabel
//               value="passport"
//               control={<Radio />}
//               label="Passsport"
//             />
//           </RadioGroup>
//           <Input
//             fullWidth
//             variant="outlined"
//             placeholder={
//               informantDetails.identificationType === "passport"
//                 ? "Passport Number"
//                 : "ID Number"
//             }
//             value={informantDetails.identificationNumber}
//             onChange={(e: any) => {
//               const value = e.target.value;
//               setInformantDetails({ identificationNumber: value });
//               clearError("identificationNumber");

//               if (informantDetails.identificationType === "id") {
//                 const error = validateSouthAfricanID(value);
//                 setErrors((prev: any) => ({
//                   ...prev,
//                   identificationNumber: error || "",
//                 }));
//               } else {
//                 setErrors((prev: any) => {
//                   const newErrors = { ...prev };
//                   delete newErrors.identificationNumber;
//                   return newErrors;
//                 });
//               }
//             }}
//             error={Boolean(errors.identificationNumber)}
//             helperText={errors.identificationNumber}
//           />
//         </Grid>

//         {/* WhatsApp Notifications */}
//         <Grid size={{ xs: 12, md: 4 }} textAlign="left">
//           <Typography sx={{ mb: 1, fontSize: 18, fontWeight: 600 }}>
//             WhatsApp Notifications
//           </Typography>

//           <FormControlLabel
//             control={
//               <Switch
//                 color="success"
//                 checked={informantDetails.whatsappNotifications ?? false}
//                 onChange={(e) =>
//                   setInformantDetails({
//                     whatsappNotifications: e.target.checked,
//                   })
//                 }
//               />
//             }
//             label={informantDetails.whatsappNotifications ? "Yes" : "No"}
//           />
//         </Grid>

//         {/* SMS Notifications */}
//         <Grid size={{ xs: 12, md: 4 }} textAlign="left">
//           <Typography sx={{ mb: 1, fontSize: 18, fontWeight: 600 }}>
//             SMS Notifications
//           </Typography>

//           <FormControlLabel
//             control={
//               <Switch
//                 color="success"
//                 checked={informantDetails.smsNotifications ?? false}
//                 onChange={(e) =>
//                   setInformantDetails({
//                     smsNotifications: e.target.checked,
//                   })
//                 }
//               />
//             }
//             label={informantDetails.smsNotifications ? "Yes" : "No"}
//           />
//         </Grid>

//         <OtpPopup
//           open={showOtp}
//           otpValue={otpValue}
//           onClose={() => setShowOtp(false)}
//           onVerify={handleOtpVerify}
//           getOtpValue={setOtpValue}
//           cellPhoneNumber={cellPhoneNumber}
//           onResendOtp={() => sendOtp(cellPhoneNumber)}
//         />
//         <VerifiedPopup
//           label="Verified"
//           open={showVerified}
//           onClose={handleVerifiedClose}
//         />
//       </Grid>

//       {/* Buttons */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "flex-end",
//           mt: 5,
//         }}
//       >
//         {/* <ButtonComp variant="outlined" height={40} width={190}>
//           Save as Draft
//         </ButtonComp> */}

//         <ButtonComp
//           variant="contained"
//           height={40}
//           width={190}
//           onClick={handleNextClick}
//         >
//           Next
//         </ButtonComp>
//       </Box>
//     </Paper>
//   );
// }

import { useCaseCreationStore } from "../../../../store/useCaseCreationStore";
import InformantDetailsForm from "../../components/forms/InformantDetailsForm";

export default function InformantDetails({ onNext, minimalCapture = false }: any) {

  const { informantDetails, setInformantDetails } = useCaseCreationStore();

  return (
    <InformantDetailsForm
      informantDetails={informantDetails}
      setInformantDetails={setInformantDetails}
      onNext={onNext}
      minimalCapture={minimalCapture}
      showBranchName={false}
    />
  );
}

